module.exports = __webpack_public_path__ + "img/IT0001674056957.0625dfcb.png";